import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Library, OPTIONS } from '../library';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class ImportTimesheetService {

  constructor(private http: HttpClient) { }

  getImportTimesheets() {
    return this.http.get<any>(Library.API_ENDPOINT + 'import-timesheet/get_import_timesheets', OPTIONS);
  }

  getImportTimesheetsSearch(filters: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'import-timesheet/get_import_timesheets_search', filters, OPTIONS);
  }

  getPersonalImportTimesheets() {
    return this.http.get<any>(Library.API_ENDPOINT + 'import-timesheet/get_personal_import_timesheets', OPTIONS);
  }

  createUpdateTimeEntries(timeEntriesForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'import-timesheet/create_update_timeEntries', timeEntriesForm, OPTIONS);
  }

  createUpdateTimesheet(timesheet: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'import-timesheet/create_update_timesheet', timesheet, OPTIONS);
  }

  createTimesheetLine(timesheet: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'import-timesheet/create_timesheet_line', timesheet, OPTIONS);
  }

  updateTimesheetLine(timesheet: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'import-timesheet/update_timesheet_line', timesheet, OPTIONS);
  }

  deleteTimeEntries(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `import-timesheet/delete_time_entries/${id}`, OPTIONS);
  }

  deleteTimesheetLine(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `import-timesheet/delete_timesheet_line/${id}`, OPTIONS);
  }

  deleteTimesheet(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `import-timesheet/delete_timesheet/${id}`, OPTIONS);
  }

  updateTimeEntries(timeEntriesForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'import-timesheet/update_timeEntries', timeEntriesForm, OPTIONS);
  }

  approveTimesheet(file: Blob, id: number): Observable<any> {
    const formData = new FormData();
    const randomFilename = `signature-${uuidv4()}.pdf`;

    formData.append('file', file, randomFilename);

    const params = new HttpParams().set('filename', randomFilename);

    return this.http.post<any>(
      `${Library.API_ENDPOINT}import-timesheet/approve_timesheet/${id}`,
      formData,
      {
        params,
        headers: new HttpHeaders()
      }
    );
  }
}
